import React, { useEffect, useRef, useState } from 'react';

import {
  AddEmployee,
  AddProjects,
  Cancel,
  Submit,
} from '../../../../pages/Manage/ManageConstants';
import LoadingButton from '@mui/lab/LoadingButton';
import IconButton from '@mui/material/IconButton';
import {
  Button,
  Grid,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { SHOW_NOTIFICATION } from '../../../../constants';
import { useDispatch } from 'react-redux';
import PersonAddAltTwoToneIcon from '@mui/icons-material/PersonAddAltTwoTone';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import AddResourceComponent from '../../../../components/ProjectCard/ProjectResource/AddResourceComponent';
import {
  addProjectsAndEmployees,
  updateProjectsAndEmployees,
} from '../../../../services/ProjectService';
import { ACTIVE_PROJECT, UserType } from '../../../../constants';
import './ManageProjectComponent.css';
import KeycloakService from '../../../../services/KeycloakService';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';
import MuiTextField from '@mui/material/TextField';

const TextField = styled(MuiTextField)(`
  .${inputLabelClasses.root} {
    
    font-size: 18px !important;
    background-color: #fff !important;
    &.${inputLabelClasses.focused} {
      font-size: 20px !important;
      background-color: #fff!important;
      padding-right: 5px !important;
    }
  }
`);

const AddProjectComponent = (props) => {
  const {
    loadData,
    project,
    expanded,
    setExpanded,
    editable,
    setEditable,
    userMappedProjects,
    resetProject,
    setPage,
    allProjects,
  } = props;
  const [addEmp, setAddEmp] = useState([]);
  const myRefs = useRef([]);
  const dispatch = useDispatch();
  const [projectName, setProjectName] = useState(project.name);
  const [projectStartDate, setProjectStartDate] = useState(project.startDate);
  const [projectDescription, setProjectDescription] = useState(
    project.description,
  );
  const [isDateValid, setIsDateValid] = useState(true);
  const [error, setError] = React.useState(null);
  const [nameError, setNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState(false);
  const [descErrorMessage, setDescNameErrorMessage] = useState(false);
  const postsPerPage = 3;
  const [pId, setPId] = useState(project.pId);
  const [pageNo, setPageNo] = useState(1);
  const [loadingApiCall, setLoadingApiCall] = useState(false);
  const currentUserId = () => KeycloakService.getUserDetail();

  const lastIndex = (pageNo - 1) * postsPerPage + postsPerPage;
  const clearProjectData = () => {
    resetProject();
    setAddEmp([]);
  };
  const errorMessage = React.useMemo(() => {
    switch (error) {
      case 'invalidDate': {
        setIsDateValid(false);
        return 'Invalid date';
      }
      default: {
        setIsDateValid(true);
        return '';
      }
    }
  }, [error]);

  const handleCancelForm = () => {
    setExpanded(!expanded);
    setNameError('');
    setProjectDescription('');
    setNameErrorMessage('');
    setDescriptionError('');
    setDescNameErrorMessage('');
    setProjectName('');
    setEditable(false);
  };

  const setFormData = () => {
    setProjectName(project.name);
    setProjectStartDate(project.startDate);
    setProjectDescription(project.description);
    setPId(project.pId);
  };
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  useEffect(() => {
    setFormData();
  }, [project]);

  const counter = () => {
    return userMappedProjects.length % postsPerPage === 0
      ? Math.floor(userMappedProjects.length / postsPerPage)
      : Math.floor(userMappedProjects.length / postsPerPage) + 1;
  };

  const projectDataValidation = () => {
    const trimmedProjectName = projectName.trim();
    const trimmedProjectDescription = projectDescription.trim();
    let isValid = true;

    if (trimmedProjectName === '') {
      setNameError(true);
      setNameErrorMessage('Project name is required');
      isValid = false;
    }
    if (projectName.length >= 40) {
      setNameError(true);
      setNameErrorMessage(
        `Max 40 chars allowed, current ${projectName.length}`,
      );
      isValid = false;
    }

    const isDuplicate = allProjects.some(
      (project) => project.toLowerCase() === trimmedProjectName.toLowerCase(),
    );

    if (isDuplicate) {
      setNameError(true);
      setNameErrorMessage('Project name already exists.');
      return false;
    }
    if (trimmedProjectDescription === '') {
      setDescriptionError(true);
      setDescNameErrorMessage('Project description is required');
      isValid = false;
    }

    const invalidEmployees = myRefs.current.filter(
      (ref) => ref !== null && (!ref.name || ref.name.trim() === ''),
    );
    if (invalidEmployees.length > 0) {
      dipatchNotification('error', 'All employee names must be filled.');
      isValid = false;
    }

    return (
      isValid &&
      trimmedProjectName &&
      projectStartDate &&
      trimmedProjectDescription &&
      isDateValid
    );
  };

  const handleSubmitForProject = async () => {
    if (projectDataValidation()) {
      setLoadingApiCall(true);
      const dummyPayload = {
        projectName: projectName.trim(),
        startDate: moment(new Date(projectStartDate)).format('YYYY-MM-DD'),
        projectStatus: ACTIVE_PROJECT,
        description: projectDescription.trim(),
        projectEmployeeRelationDTOList: myRefs.current[0]?.id
          ? myRefs.current
              .filter((elem) => elem !== null)
              .map((item) => {
                return {
                  employeeId: item.id,
                  projectId: item.projectId,
                  isManager: item.role === 'Manager',
                  status: 'ACTIVE',
                  startDate: moment(new Date(projectStartDate)).format(
                    'YYYY-MM-DD',
                  ),
                };
              })
          : [],
      };
      const result = await addProjectsAndEmployees(dummyPayload);
      setLoadingApiCall(false);
      setProjectName('');
      setProjectDescription('');
      setAddEmp([]);
      setExpanded(!expanded);
      setNameError('');
      setDescriptionError('');
      setNameErrorMessage('');
      setDescNameErrorMessage('');
      if (result.status === 200) {
        loadData();
      }
      dipatchNotification(result.type, result.message);
    } else {
      window.scrollTo(0, 0); // scroll to the top of the page
    }

    counter();
  };

  const updateProjectPayload = () => {
    return {
      id: pId,
      projectName: projectName.trim(),
      projectStatus: ACTIVE_PROJECT,
      description: projectDescription.trim(),
      startDate: moment(new Date(projectStartDate)).format('YYYY-MM-DD'),
    };
  };
  const handleRemoveItem = (index) => {
    const tempItemArr = [...myRefs.current];
    const newTempItemArr = [...tempItemArr];
    newTempItemArr[index].role = '---';
    setAddEmp((prev) => [...newTempItemArr]);
  };

  const addAnotherColumn = () => {
    setAddEmp((prev) => [...prev, { id: '', name: '', role: '' }]);
  };
  const projectEditable = async () => {
    if (projectDataValidation()) {
      setLoadingApiCall(true);
      const editProjectPayload = updateProjectPayload();
      const editResponse = await updateProjectsAndEmployees(editProjectPayload);
      counter();
      setLoadingApiCall(false);
      loadData();
      setProjectName('');
      setProjectDescription('');
      setExpanded(!expanded);
      setEditable(false);
      dipatchNotification(editResponse.type, editResponse.message);
    } else {
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setPage(1);
  };

  return (
    <div>
      {(KeycloakService.hasRole([UserType.ADMIN]) ||
        KeycloakService.hasRole([UserType.PROJECT_ADMIN])) && (
        <Accordion
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}
          disableGutters
          elevation={0}
        >
          <Grid
            sx={{ backgroundColor: expanded ? '' : '#f7f8fa' }}
            container
            justifyContent="flex-end"
            pb={0}
            pr={0}
          >
            <AccordionSummary>
              {!expanded ? (
                <Button
                  variant="contained"
                  onClick={clearProjectData}
                  startIcon={<AddIcon fontSize="small" />}
                >
                  {AddProjects}
                </Button>
              ) : null}
            </AccordionSummary>
          </Grid>
          <AccordionDetails>
            <Box
              component="form"
              sx={{
                mx: 10,
                mb: 2,
              }}
              noValidate
              autoComplete="off"
            >
              <div className="space-between-container margin-bottom-form">
                <TextField
                  name="name"
                  value={projectName}
                  onChange={(e) => {
                    const value = e.target.value;
                    const isDuplicate = allProjects.some(
                      (project) =>
                        project.toLowerCase() === value.trim().toLowerCase(),
                    );

                    if (isDuplicate) {
                      setNameError(true);
                      setNameErrorMessage('Project name already exists.');
                    } else if (!value.trim()) {
                      setNameError(true);
                      setNameErrorMessage('Project name cannot be empty.');
                    } else {
                      setNameError(false);
                      setNameErrorMessage('');
                    }

                    setProjectName(value);
                  }}
                  id="project-name"
                  error={nameError}
                  helperText={nameErrorMessage}
                  label="Project Name"
                />

                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  sx={{ display: 'none' }}
                >
                  <DatePicker
                    onError={(newError) => setError(newError)}
                    slotProps={{
                      textField: {
                        helperText: errorMessage,
                      },
                    }}
                    label="Start Date"
                    inputFormat="YYYY-MM-DD"
                    value={projectStartDate}
                    onChange={(newValue) => {
                      setProjectStartDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={!isDateValid}
                        helperText={errorMessage}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="margin-bottom-form margin-bottom-form">
                <TextField
                  name="description"
                  id="standard-multiline-static"
                  label="Project Description"
                  value={projectDescription}
                  error={descriptionError}
                  helperText={descErrorMessage}
                  onChange={(e) => {
                    if (e.target.value) {
                      setDescriptionError('');
                      setDescNameErrorMessage('');
                    }
                    setProjectDescription(e.target.value);
                  }}
                  multiline
                  rows={4}
                  fullWidth
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  hidden={editable}
                  sx={{
                    borderRadius: 10,
                    marginBottom: '5%',
                  }}
                  variant="contained"
                  color="secondary"
                  startIcon={<PersonAddAltTwoToneIcon />}
                  onClick={() => {
                    addAnotherColumn();
                  }}
                >
                  {AddEmployee}
                </Button>
              </div>
              {!editable &&
                addEmp.map((emp, i) => (
                  <div key={i}>
                    {emp?.role !== '---' && emp !== null && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: '2%',
                        }}
                      >
                        <div style={{ flexBasis: '90%' }}>
                          <AddResourceComponent
                            ref={(el) => (myRefs.current[i] = el)}
                            currentProjectEmployees={myRefs.current}
                          />
                        </div>
                        <div>
                          <IconButton
                            color="error"
                            onClick={(e) => handleRemoveItem(i)}
                          >
                            <DeleteTwoToneIcon />
                          </IconButton>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              <div
                className="space-between-container mb"
                sx={{ width: '100px', marginBottom: '3rem' }}
              >
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleCancelForm()}
                >
                  {Cancel}
                </Button>
                <LoadingButton
                  loading={loadingApiCall}
                  onClick={() => {
                    editable ? projectEditable() : handleSubmitForProject();
                  }}
                  variant="contained"
                >
                  {loadingApiCall ? 'loading...' : Submit}
                </LoadingButton>
              </div>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {/* {KeycloakService.hasRole([UserType.ADMIN])?(<div>true</div>):(<div>false</div>)} */}
      {/* {editable?(<div>true</div>):(<div>false</div>)} */}
    </div>
  );
};
export default AddProjectComponent;
